import * as React from "react"
import { batch } from '@preact/signals-react'
import { Box, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"
import { FORMAT_DATE_BACK, formatDate, getPreviousDate } from "@ui-seeker/utils"

import { DATE_PERIODS, GROUPED_BY } from "@constants"
import { SkuInfoBlock } from "@components"
import { useBuildExternalURL } from "@hooks"
import { commonFiltersValue } from "@signals"
import { marketAnalyzerEvolutionSkuFilters, marketAnalyzerSkuDetailsFilters, marketAnalyzerEvolutionSkuCurrentPeriod, marketAnalyzerEndDate } from "../../../@signals"


export default function skuRetailerColumn() {
	return [{
        name: 'category', label: 'Category',
        options: {
            display: 'excluded'
        }
    }, {
        name: 'brand', label: 'Brand',
        options: {
            display: 'excluded'
        }
    }, {
		name:'ean', label: 'EAN',
		options: {
			display: 'excluded',
			filterType: 'textField'
		}
	}, {
		name: 'sku', label: 'Product Name',
		options: {
			headerAlign: 'left',
            filterType: 'textField',
			customBodyRowRenderLite: (value, { category, brand, ean, skuID, productID, myMainSiteID, country, reference }) =>
                <SkuRetailerCell
                    sku={value}
                    productID={productID}
                    category={category}
                    brand={brand}
                    ean={ean}
                    skuID={skuID}
                    myMainSiteID={myMainSiteID}
                    country={country}
                    reference={reference}
                />
		}
	}]
}

const SkuRetailerCell = ({ sku, productID, category, brand, ean, skuID, myMainSiteID, country, reference}) => {
    const newFilters = commonFiltersValue.peek()
    const { productURL } = useBuildExternalURL({ siteData: { siteID: myMainSiteID, productID } })

    const handleClick = () => { batch(() => {
        marketAnalyzerEndDate.value = newFilters.endDate
        let startDate = formatDate(getPreviousDate({days: 6}, marketAnalyzerEndDate.value), { format: FORMAT_DATE_BACK, receivedFormat: "%Y-%m-%dT%H:%M:%S.%LZ" })

        marketAnalyzerEvolutionSkuCurrentPeriod.value = DATE_PERIODS.LAST_7_DAYS

        marketAnalyzerEvolutionSkuFilters.value = {
            ...commonFiltersValue.peek(),
            startDate: startDate,
            endDate: marketAnalyzerEndDate.value,
            sku: [skuID],
            country: [country]
        }
    })}

    const handleClickDetails = () => { batch(() => {
        marketAnalyzerSkuDetailsFilters.value = {
            ...commonFiltersValue.peek(),
            sku: [skuID],
            country: [country],
            skuName: sku,
            splitKpi: GROUPED_BY.SKU
        }
    })}

    return <>
        <SkuInfoBlock
            sku={sku}
            productURL={productURL}
            category={category}
            brand={brand}
            ean={ean}
            skuID={skuID}
            reference={reference}
        />  

       <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 1}} onClick={handleClick} >
            <Typography variant="caption" sx={{ display: 'block', color: "text.primary", mt: 1, mr: 0.5, cursor: 'pointer', "&:hover":{ fontWeight: 'bold' } }}>
                Show Price Evolution 
            </Typography>
            <IconSeeker icon={'chart-line'} sx={{ mr: 0.5, margin: .5, color: 'primary.main' }}/>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'flex-end'}} onClick={handleClickDetails} >
            <Typography variant="caption" sx={{ display: 'block', color: "text.primary", mt: 1, mr: 0.5, cursor: 'pointer', "&:hover":{ fontWeight: 'bold' } }}>
                Show daily details
            </Typography>
            <IconSeeker icon={'magnifying-glass'} sx={{ mr: 0.5, margin: .5, color: 'primary.main'}}/>
        </Box>
    </>
}